export const SET_HEADER_SEARCH_FOCUSED = 'GCG/SET_HEADER_SEARCH_FOCUSED';
export const setHeaderSearchFocused = (isFocused) => ({
    type: SET_HEADER_SEARCH_FOCUSED,
    isFocused
});
